<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SD"></ad-campaign-select>
        <gj-select
            v-model="status"
            :options="AdGroupEnum.SD.statusOption"
            placeholder="状态"
        ></gj-select>
        <gj-lazy-input
            v-model="groupName"
            placeholder="广告组名称"
            width="120px"
        ></gj-lazy-input>
        <gj-date-picker
            v-model="date"
            :clearable="false"
            type="daterange"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSdCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdGroups/export" :download-params="globalParams"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          v-if="false"
          type="primary"
          @click="add"
      >新增广告组</gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdGroupEnum.SD.status.ARCHIVE)"
          @click="adjustBid">
        调整竞价
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdGroupEnum.SD.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdGroupEnum.SD.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSdCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdGroupEnum.SD.status.ENABLE, AdGroupEnum.SD.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdGroups/export" :download-params="globalParams"
          :helpName="helpName"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSdCampaigns:addOrUpdate')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          show-summary
          :selectable="notEqSelectable('state', AdGroupEnum.SD.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSdCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdGroupEnum.SD.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdGroupEnum.SD.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdGroupEnum.SD.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:groupName="{ row }">
          <template v-if="row.state === AdGroupEnum.SD.status.ARCHIVE || !$permission('adsSdCampaigns:addOrUpdate')">
            {{row.groupName | defaultShow}}
          </template>
          <div v-else style="display: flex; align-items: center;">
            <gj-edit-input
              :value="row.groupName"
              :item="row"
              table-cell-edit
              :validator="groupNameValidator"
              :on-confirm="updateGroupName"
              :pop-title="'广告组名称'">
              <app-sd-ad-route-link
                  :ad-group-manager="{marketId, campaign: row, group: row, date}">
                <gj-tooltip
                    :text-line="2"
                    :content="row.groupName">
                  {{row.groupName | defaultShow}}
                </gj-tooltip>
              </app-sd-ad-route-link>
            </gj-edit-input>
            <div class="gj-cell-display-switch">
              <app-ad-route-link :market-id="row.marketId" :type="AdTypeEnum.SD" :campaign="row" :group="row">
                <gj-tooltip content="新标签页打开" >
                  <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                </gj-tooltip>
              </app-ad-route-link>
            </div>
          </div>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sd-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin, currencySymbolMixin,
    adAdvancedFilteringMixin,
    inCampaignMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {queryMixin, selectionMixin} from "../../../../../../minxins";
  import {AdGroupEnum} from "../../../common/enum";
  import AppAdjustBidModal from "../../../common/modal/adjust/adjust-bid-modal";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppAddSdAdGroup from "../../common/modal/add/group/add-ad-group";
  import AppSdAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../../utils/common";
  import {getSdAdGroupPage, updateSdAdGroup} from "../../../../../../api/ad";
  import {subDays} from 'date-fns';
  import {convertToDate} from "../../../../../../utils/date.util";
  import {adStore} from "../../../common/store";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import {LOG_OP_TYPE} from "../../../common/options";
  import { AdTypeEnum } from "modules/ad/common/enum";
  import AppAdRouteLink from "modules/ad/common/components/app-ad-route-link.vue";

  export default {
    name: "app-sd-ad-group",
    components: {AppSdAdRouteLink, AdCampaignSelect, AppAdRouteLink},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin,
      queryMixin, currencySymbolMixin,
      adDefaultSortMixin, initDateMixin,
      adAdvancedFilteringMixin
    ],
    created() {
      this.columns = [
        adFields.status,
        adFields.groupName,
        {...adFields.servingStatus, options: AdGroupEnum.SD.servingStatusOption},
        {...adFields.groupTargetType, field: 'option:tactic', options: AdGroupEnum.SD.targetingTypeOption},
        adFields.productNum,
        adFields.targetNum,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        {...adFields.bid, field: 'defaultBid'},
        // adFields.creationDate,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        // adFields.orderProductSales,
        adFields.acos,
        // adFields.acoas,
        // adFields.asoas,
        adFields.roas,
        adFields.op,
      ].filter(e => e !== null);
    },
    data() {
      return {
        AdTypeEnum,
        helpName:'sdadmanager',
        campaignIds: [],
        tableData: [],
        columns: [],
        AdGroupEnum: AdGroupEnum,
        // filter
        status: AdGroupEnum.SD.status.ENABLE_PAUSE,
        timeStamp: null,
        groupName: null,
        extendSearch: null,
        date: null
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    methods: {
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          status: AdGroupEnum.SD.status.ENABLE_PAUSE,
          timeStamp: this.$route.query.timeStamp,
          groupName: this.$route.query.keyword||null,
          extendSearch: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()]
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            campaignIds: this.campaignIds,
            marketId: this.marketId,
            campaignId: this.campaignId,
            groupName: this.groupName,
            extendSearch: this.extendSearch,
            state: defaultVal(this.status, null),
            startDate: convertToDate(this.date[0]),
            endDate: convertToDate(this.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSdAdGroupPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, adStore.SD.currencySymbol);
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      add() {
        const modal = this.$gjCreate(AppAddSdAdGroup, {
          props: {
            campaign: this.campaign
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.$gjDestroy()
            }
          }
        });
      },
      groupNameValidator(name) {
        return isMeaningful(name);
      },
      updateGroupName(name, row, closeEditor, closeLoading) {
        updateSdAdGroup({
          marketId: this.marketId,
          groupIds: [row.groupId],
          groupName: name,
        })
          .then(() => {
            this.$gjMessage.success('操作成功');
            closeEditor();
            this.$gjResetPage();
          })
          .complete(() => closeLoading());
      },
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SD.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdGroup({
                marketId: this.marketId,
                groupIds: this.selectedRows.map(e => e.groupId),
                adjustmentType: modal.form.bid.key,
                adjustmentValue: modal.form.bid.value,
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告组，确认启用？` : `确认启用广告组[${rows[0].groupName}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdGroup({
                marketId: this.marketId,
                groupIds: rows.map(e => e.groupId),
                state: AdGroupEnum.SD.status.ENABLE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告组，确认停用？`: `确认停用广告组[${rows[0].groupName}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdGroup({
                marketId: this.marketId,
                groupIds: rows.map(e => e.groupId),
                state: AdGroupEnum.SD.status.PAUSE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdGroup({
                marketId: this.marketId,
                groupIds: this.selectedRows.map(e => e.groupId),
                state: AdGroupEnum.SD.status.ARCHIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            campaignId: this.campaignId,
            name: isMeaningful(row) ? row.groupName : '',
            opId: isMeaningful(row) ? row.groupId : null,
            adType: LOG_OP_TYPE.SD,
            object: LOG_OP_TYPE.SD.GROUP
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
